import { Container, Col, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import UserAgreement from './UserAgreement';

function ConsentPage() {
    const history = useHistory();

    return (
        <Container fluid>
            <Row>
                <Col xs={12}>
                    <UserAgreement
                        surveyId={'mfq'}
                        startSurvey={() =>
                            history.push({
                                pathname: '/callback',
                                state: { collectData: true }
                            })
                        }
                    />
                </Col>
            </Row>
        </Container>
    );
}

export default ConsentPage;
